import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon_camera.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_info_circle.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { id: "section-upload-photo" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "camera-image"
}
const _hoisted_5 = { class: "font-semibold text-sm text-gray-lp-300" }
const _hoisted_6 = { class: "flex flex-row gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row gap-1 items-center mt-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "info-image"
}, null, -1)
const _hoisted_9 = { class: "text-xs text-gray-lp-300" }
const _hoisted_10 = {
  key: 1,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 mt-2"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadPhotoCodReconcile = _resolveComponent("UploadPhotoCodReconcile")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.iconTitle)
          ? (_openBlock(), _createBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.foto")), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attachmentImage, (photo, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            _createVNode(_component_UploadPhotoCodReconcile, {
              accept: "image/png, image/jpg, image/jpeg, image/webp",
              onUpload: _ctx.onUpload,
              onRemove: _ctx.onRemove,
              onPreview: _ctx.onPreview,
              onError: _ctx.onError,
              modelValue: _ctx.attachmentImage[index],
              maxSize: 5,
              multipleIndex: index
            }, null, 8, ["onUpload", "onRemove", "onPreview", "onError", "modelValue", "multipleIndex"])
          ]))
        }), 128))
      ]),
      (!_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.uploadPhotoHint")), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("span", null, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.uploadPhotoError")), 1)
          ]))
    ])
  ]))
}